import { TMessageBarSeverity } from 'types';
import { IPriceChangedFields } from '@utils/sales/offer';
import { ICalculation } from 'next-common';

export const enum AppEnv {
  Production = 'production',
  Preprod = 'preprod',
  Devtest = 'devtest',
  Development = 'development',
  Local = 'local',
}

export enum PageSteps {
  START = 0,
  DETAILS = 10,
  PACKAGES = 1,
  FINANACE = 2,
  IMPORTEROPTIONS = 3,
  SIGN = 4,
}

export enum SOURCE_CONTEXT {
  SALES_COMMON = 'SalesCommon',
  NEXT = 'Next',
}

export interface IStepData {
  activeStep: number;
  route: string;
  routeIsActive: boolean;
  routeIsActiveClass: string;
  routeName: string;
}

export enum INotificationType {
  PIM_DATA_UNAVAILABLE = 'PIMDataUnavailable',
  DISCOUNT_CHANGED = 'DiscountChanged',
  CUSTOMER_ERROR = 'CustomerError',
  PRESELECTION_ERROR = 'PreselectionError',
  RESERVED_WARNING = 'ReservedWarning',
  VEHICLE_STOCK_CONFIGURATION_ERROR = 'VehicleStockConfigurationError',
  STOCK_SALE_VEHICLE_STOCK_CONFIGURATION_ERROR = 'StockSaleVehicleStockConfigurationError',
  FACTORY_CODE_UNAVAILABLE = 'FactoryCodeUnavailable',
  RESERVED_FAIL = 'ReservedFail',
  REMOVE_VEHICLE_FAIL = 'RemoveVehicleFail',
  CHOOSE_OFFER_FAIL = 'ChooseOfferFail',
  VEHICLE_ADD_ERROR = 'VehicleAddError',
  ADD_VEHICLE_ERROR = 'AddVehicleError',
  TOGGLE_ACCESSORY_FAIL = 'ToggleAccessoryFail',
  REMOVE_LEASING = 'RemoveLeasing',
  SERVICE_CONTRACT_WARNING = 'ServiceContractWarning',
  ADD_CALCULATION_FAIL = 'AddCalculationFail',
  REMOVE_CALCULATION_FAIL = 'RemoveCalculationFail',
  OFFER_CREATION_ERROR = 'OfferCreationError',
  PRICE_CHANGE = 'PriceChange',
  TOGGLE_PCODES_FAIL = 'TogglePcodesFail',
  INTEREST_WARNING = 'InterestWarning',
  CUSTOMER_WARNING = 'CustomerWarning',
  VEHICLE_MISSING_WARNING = 'VehicleMissingWarning',
  EXECUTE_SIGN_FAIL = 'ExecuteSignFail',
  VEHICLE_ORDER_DRAFT_ERROR = 'VehicleOrderDraftError',
  FILE_SELECTION_ERROR = 'FileSelectionError',
  RESERVED_CAR = 'ReservedCar',
  UPDATE_BRUKS_CODE_FAIL = 'UpdateBruksCodeFail',
  RECALCULATION_FAIL = 'RecalculationFail',
  FACTORY_ORDER_WARNING = 'FactoryOrderWarning',
  ONE_OFF_TAX_UNAVAILABLE = 'OneOffTaxUnavailable',
  INVALID_TIME_VALUE = 'InvalidTimeValue',
  PROD_DATE_WARNING = 'ProdDateWarning',
  VAT_ERROR = 'VatError',
  INVALID_VEHICLE_STOCK_STATUS_ERROR = 'InvalidvehicleStockStatusError',
  VEHICLE_VALIDATION_ERROR = 'VehicleValidationError',
  SHARE_CODE_ERROR = 'ShareCodeError',
  SHARE_CODE_UPDATE_FAILED = 'ShareCodeUpdateFailed',
}

export interface INotificationDetails {
  key: string;
  type: INotificationType;
  errorCode?: number;
  severityLevel?: TMessageBarSeverity;
  title?: string;
  message?: string;
  serialNo?: string;
  orderId?: string;
  hideLink?: boolean;
  priceChangedFields?: IPriceChangedFields[];
  chosenOffer?: ICalculation;
  fields?: string[];
  invalidItems?: string[];
  className?: string;
  onClose?: () => void;
}
